/********************************************************************************
Filename: np-product-card.js
Created: 29 Nov 2022
Author: Ron Robertson
Description: Displays product image, title, short description. Clicking navigates
to product page.
Usage Example:
<np-product-card></np-product-card>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            #productCard{
                position: relative;
                width: 100%;
                height: 100%;
                text-decoration: none;
                color: #000000;
                display: flex;
                flex-direction: column;
                justify-content: center;
                transition: all 0.3s ease-in-out;
                border-radius: 8px;
                box-sizing:border-box;
                padding: 56px 20px;
            }

            #productCard:hover{
              background-color: #ffffff;

            }
            #productCard.theme-alt:hover{
              background-color: #f2f2f2;
            }
            #name{
                font-family: var(--neue-haas-display-55);
                font-weight:normal;
                font-size: 28px;
                line-height: 1.2;
                text-align: center;
                margin-bottom: 4px;
            }
            #name sup{
              vertical-align: baseline;
              position: relative;
              top: -0.3em;
            }
            #description {
                font-family: var(--neue-haas-display-55);
                font-weight:normal;
                font-size: 18px;
                text-align: center;
                color: #7e7e7e;
                //width: calc((var(--col-width) * 3) + var(--gutter-width) * 4);
                margin:0 auto;
                max-width: 280px;
                min-height: calc(1.2em * 2);
            }
            .visual{
                text-align: center;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                box-sizing: border-box;
                padding-bottom:24px;

            }
            .visual img{
              max-width: 100%;
              max-height: 100%;
              transition:all 0.3s ease-in-out;
              transform: scale(0.95);
            }
            #productCard:hover .visual img{
              padding:0;
              transform: scale(1);
            }

            #label {
              display: none;
              background-color: #26B8FC;
              border-radius: 3px;
              padding: 7px 10px;
              position: absolute;
              top: 20px;
              right: 20px;
              color: #fff;
            }
            #label.visible {
              display:inline-block;
            }
        </style>

        <a id='productCard' href=''>
            <div class='visual'>
                <img
                id='img'
                alt=''
                src=''
                srcset='' >
            </div><!--END visual-->
            <div class='copy'>
                <div id='name'></div>
                <p id='description'></p>
            </div><!--END copy-->
            <div id='label' class='label'></div>
        </a>
    `;

    class NpProductCard extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            /* this.myMethod = this.myMethod.bind(this); */

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.productCard= this.shadowRoot.getElementById('productCard');
            this.imgEle= this.shadowRoot.getElementById('img');
            this.nameEle= this.shadowRoot.getElementById('name');
            this.labelEle= this.shadowRoot.getElementById('label');
            this.descriptionEle = this.shadowRoot.getElementById('description')

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            /*
            if (!this.hasAttribute('myattribute')) {
                this.setAttribute('myattribute', "value");
            }
            */

            /* Set Event Listeners */
            /* this.myBtn.addEventListener('click', this.myMethod); */

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return ['src', 'srcset', 'name', 'description', 'url', 'theme', 'label'];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {
        if(name === 'src') {
            this.imgEle.setAttribute('src', newValue);
        }else if(name === 'srcset') {
            //this.imgEle.setAttribute('srcset', newValue);
        }else if(name === 'name') {
            this.nameEle.innerHTML = newValue;;
        }else if(name === 'description') {
            this.descriptionEle.innerHTML = newValue;
        }else if(name === 'url') {
          this.productCard.setAttribute('href', newValue);
        }else if(name === 'theme') {
          this.productCard.classList.remove('theme-'+oldValue);
          this.productCard.classList.add('theme-'+newValue);
        }else if(name === 'label') {
          this.labelEle.classList.add('visible');
          this.labelEle.innerHTML = newValue;

        }

       }/* END attributesChangedCallback */

      /* Getting attributes */
      get src() {
        return this.getAttribute('src');
      }
      get srcset() {
        return this.getAttribute('srcset');
      }
      get name() {
        return this.getAttribute('name');
      }
      get description() {
        return this.getAttribute('description');
      }
      get url() {
        return this.getAttribute('url');
      }
      get theme() {
        return this.getAttribute('theme');
      }

      /* Settinng attributes */
      set src(newValue) {
        this.setAttribute('src', newValue);
      }
      set srcset(newValue) {
        this.setAttribute('srcset', newValue);
      }
      set name(newValue) {
        this.setAttribute('name', newValue);
      }
      set description(newValue) {
        this.setAttribute('description', newValue);
      }
      set url(newValue) {
        this.setAttribute('url', newValue);
      }
      set theme(newValue) {
        this.setAttribute('theme', newValue);
      }

      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
        this.myBtn.removeEventListener('click', this.myMethod);
      }

        /* Method */
        /*
        myMethod(e) {
            e.preventDefault();

        }
        */

    } /* END class */

    window.customElements.define('np-product-card', NpProductCard);

  })();
